import axios from 'axios';

let getStudentsPromises: Record<string, Promise<any>> = {};

const getStudents = async (studyGroupId: string) => {
  if (!getStudentsPromises[studyGroupId]) {
    getStudentsPromises[studyGroupId] = axios.get('/api/v1/users/students/', {
      params: {
        format: 'json',
        study_group: studyGroupId,
      },
      headers: {
        'X-CSRFToken': JSON.parse(
          document.getElementById('csrf_token')!.innerHTML,
        ),
      },
    });
  }
  const response = await getStudentsPromises[studyGroupId];
  return response.data.results;
};

export default getStudents;
